import { get } from '../http';

const GET_PERSON_URL = '/rest/v1/my/person';

export default async function getPerson() {
  const url = GET_PERSON_URL;
  return get({ url });
}
